import React from 'react';

import {
  AlertBannerContainer,
  DashboardLoader,
  Iframe as DashboardIframe,
} from '../../../components';
import { AlertBannerKindEnum } from '../../../components/AlertBannerContainer/AlertBannerContainer';
import { ChatOverlayProvider } from '../../../context/chatOverlayContext';
import { useIspmContext } from '../../../context/ispmContext';
import { ispmEnvironmentSettings, Logger } from '../../../services';
import { useInvertedLocalize } from '../../../utils/localization';
import { invertedMessages } from '../../../utils/messages';
import SaviChatOverlay from '../../SaviChat/SaviChat';

interface ChatOrDashboardProps {
  testId: string;
}

ChatOrDashboard.default = {
  testId: '',
};

function ChatOrDashboard({ testId }: ChatOrDashboardProps) {
  Logger.info('Insight Dashboard --> ChatOrDashboard component');

  const { ispmState } = useIspmContext();
  const l = useInvertedLocalize(invertedMessages);

  return ispmState.isChatOverlayVisible ? (
    <ChatOverlayProvider>
      {/* Visibility of AlertBanner is handled inside the component */}
      <AlertBannerContainer kind={AlertBannerKindEnum.SystemError} />
      <SaviChatOverlay />
    </ChatOverlayProvider>
  ) : (
    <DashboardIframe
      iframeUrl={ispmEnvironmentSettings.IFRAME_URL}
      title={l('Apache superset dashboard')}
      testId={testId}
      LoaderComponent={<DashboardLoader testId={`${testId}-dashboardLoader`} />}
    />
  );
}

export default ChatOrDashboard;
